module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-human-4d31dd583c39ce518d2a847528db89fa.png";